import React, { useState, useEffect } from "react";

import { transformTableData } from "../utils/dataTransforms";
import { createBasicColumn, createCurrencyColumn } from "./TableColumnConfig";
import { TableWrapper, getCommonTableOptions } from "./TableConfig";

const CARR = (props) => {
    const [carrTableData, setCarrTableData] = useState([]);

    useEffect(() => {
        if (!props.data || props.data.length === 0) return;

        const transformedData = transformTableData(props.data, {
            currencyFields: ["ending_carr"],
        });

        // Handle Total CARR row highlighting
        const finalData = transformedData.map((item) => {
            if (item.product === "Total CARR" && item.ending_carr !== "-") {
                return {
                    ...item,
                    product: <strong>{item.product}</strong>,
                    ending_carr: <strong>{item.ending_carr}</strong>,
                };
            }
            return item;
        });

        setCarrTableData(finalData);
    }, [props.data]);

    const columns = [
        createBasicColumn("product", "Product"),
        createCurrencyColumn("ending_carr", "Ending CARR", "150px"),
    ];

    return (
        <div className="mt-12 flex w-full flex-col">
            <h4 className="pl-2">CARR by Product</h4>
            <TableWrapper
                data={carrTableData}
                columns={columns}
                options={getCommonTableOptions("CARR")}
                loading="Loading CARR data..."
            />
        </div>
    );
};

export default CARR;
